import { useAtomValue } from 'jotai';
import modularPdpAtom from './modularPdpAtom';
const useModularPdp = () => {
  const modularPdp = useAtomValue(modularPdpAtom);
  return modularPdp;
};
export default useModularPdp;